<template>
  <div class="login">
    <Header></Header>
    <div class="center_">
      <div class="middle">
        <div class="phone">
          <input
            type="text"
            placeholder="请输入手机号"
            style="margin-bottom: 0.3rem"
            maxlength="11"
            v-model="phone"
            @blur="blur1"
            oninput="value=value.replace(/[^\d]/g,'')"
          />
        </div>
        <div class="password">
          <input
            :type="pwdType"
            placeholder="请输入密码"
            maxlength="15"
            v-model="password"
            @blur="blur2"
          />
          <img
            src="../assets/有岛/eye.png"
            alt=""
            style="margin-left: -26px; margin-bottom: -4px"
            @click="changeType"
          />
        </div>
        <div
          class="test"
          style="
            margin-top: 0.3rem;
            margin-bottom: 0.3rem;
            color: rgb(169, 169, 169);
            cursor: pointer;
          "
          @click="forgetpassword"
        >
          忘记密码
        </div>
        <div
          class="log"
          style="
            line-height: 0.8rem;
            font-size: 16px;
            border: 1px solid #5a5e66;
            cursor: pointer;
          "
          @click="toLogin"
        >
          登录
        </div>
        <div
          class="log"
          style="
            line-height: 0.8rem;
            font-size: 16px;
            border: 1px solid #5a5e66;
            margin-top: 10px;
            cursor: pointer;
          "
          @click="register"
        >
          没有账号，去注册
        </div>
        <div
          style="
            margin-top: 1rem;
            color: rgb(107, 100, 96);
            width: 100%;
            text-align: center;
          "
          class="vx1"
        >
          ---使用微信登录---
        </div>
        <div
          class="vx2"
          @click="vx_login"
          style="text-align: center; margin-top: 0.2rem"
        >
          <img
            src="../assets/有岛/vx.png"
            alt=""
            style="width: 70px; border-radius: 7px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../http/http";
import browser from "../http/browser";
import Header from "../components/homepage_navbar";

export default {
  data() {
    return {
      // nickname:"",
      phone: "",
      password: "",
      pwdType: "password",
     
    };
  },
  components: {
    Header,
    // Nav,
  },
  mounted() {},
  methods: {
    register() {
      this.$router.push("/register");
    },
    changeType() {
      this.pwdType = this.pwdType === "password" ? "text" : "password";
    },
  
    
    vx_login() {
    
      let jump_lastpage=window.location.hostname == "nestudio.neone.com.cn"? "https://nestudio.neone.com.cn/#/zhongzhuan":"https://nestudio.test.neone.com.cn/dist/#/zhongzhuan"
      jump_lastpage = encodeURIComponent(jump_lastpage);

      if (browser.versions.weixin && browser.versions.mobile) {
        window.location.href =
          "https://open.neone.com.cn/wechatopen/oauth/snsapi_userinfo/wx0a7d3980317814e8?callbackurl=" +
          encodeURIComponent(
            window.apiurl +
              "/api/v1/wechat/mp/login?callbackurl=" +
              jump_lastpage
          );
      } else {
        window.location.href =
          "https://open.neone.com.cn/wechatopen/oauth/snsapi_login/wx52f2948d9390bec0?callbackurl=" +
          encodeURIComponent(
            window.apiurl +
              "/api/v1/wechat/pc/login?callbackurl=" +
              jump_lastpage
          );
      }
    
    },

    

    blur1() {
      if (this.phone.length != 11) {
        this.$message({
          showClose: true,
          message: "请输入11位的手机号",
          center: true,
        });
        return;
      }
      let myreg1 = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg1.test(this.phone)) {
        this.$message({
          showClose: true,
          message: "您输入的手机号有误，请重新输入",
          center: true,
        });
      }
    },
    blur2() {
      let myreg2 = /\w{6,15}/g;
      if (this.password == "") {
      } else if (!myreg2.test(this.password)) {
        // this.password = "";
        this.$message({
          showClose: true,
          message: "请输入6-15位的密码",
          center: true,
        });
      }
    },

    toLogin() {
      http
        .post("/api/v1/user/login", {
          mobile: this.phone,
          password: this.password,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.isSuccess == 1) {
            window.localStorage.setItem("usertoken", res.data.item.token);
            window.localStorage.setItem("mobile", res.data.item.user.mobile);
            // window.localStorage.setItem("password", this.password);
            // window.localStorage.setItem(
            //   "nickname",
            //   res.data.item.user.nickname
            // );
            // window.localStorage.setItem("userId", res.data.item.user.id);
            // window.localStorage.setItem(
            //   "skindataAll",
            //   JSON.stringify(res.data.item.user.skindata)
            // );
            if (window.localStorage.getItem("lastpage")) {
              window.location.href = window.localStorage.getItem("lastpage");
            } else {
              this.$router.push("/");
            }

            this.$message({
              showClose: true,
              message: "登录成功",
              center: true,
              type: "success",
            });
          }
          if (res.data.isSuccess != 1) {
            this.$message({
              showClose: true,
              message: res.data.message,
              center: true,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    forgetpassword() {
      this.$router.push("/forgetpassword");
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  .center_ {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    .middle {
      .phone {
        input {
          width: 7.5rem;
          height: 0.9rem;
          border: 1px solid #5a5e66;
          font-size: 14px;
          line-height: 0.9rem;
          border-radius: 10px;
          outline: none;
          text-indent: 10px;
        }
        input:focus {
          border-style: solid;
          border-color: #3aa3f3;
          box-shadow: 0 0 15px #3aa3f3;
        }
      }
      .password {
        input {
          width: 7.5rem;
          height: 0.9rem;
          border: 1px solid #5a5e66;
          font-size: 14px;
          line-height: 0.9rem;
          border-radius: 10px;
          outline: none;
          text-indent: 10px;
        }
        input:focus {
          border-style: solid;
          border-color: #3aa3f3;
          box-shadow: 0 0 15px #3aa3f3;
        }
      }

      .log {
        text-align: center;
        width: 7.5rem;
        height: 0.9rem;

        font-size: 14px;
        border-radius: 10px;
        outline: none;
      }
      .changeName {
        width: 7rem;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: white;
        box-shadow: 0 12px 48px #31323308, 0 9px 28px #3132330d,
          0 6px 16px #31323314;
        border-radius: 10px;
        z-index: 2000;
        .changeName1 {
          text-align: center;
        }
        .changeName2 {
          text-align: center;
          input {
            text-align: center;
            width: 80%;
            height: 0.9rem;
            border: 1px solid #5a5e66;
            font-size: 14px;
            line-height: 0.9rem;
            border-radius: 10px;
            outline: none;
          }
          input:focus {
            border-style: solid;
            border-color: #3aa3f3;
            box-shadow: 0 0 15px #3aa3f3;
          }
        }
        .changeName3 {
          text-align: center;
          display: flex;
          justify-content: space-evenly;
        }
        .changeName4 {
          width: 80%;
          display: flex;
          justify-content: space-between;
          margin: 0.3rem auto 0 auto;
          input {
            width: 45%;
            text-align: center;
            height: 0.9rem;
            border: 1px solid #5a5e66;
            font-size: 14px;
            line-height: 0.9rem;
            border-radius: 10px;
            outline: none;
          }
          input:focus {
            border-style: solid;
            border-color: #3aa3f3;
            box-shadow: 0 0 15px #3aa3f3;
          }
        }
      }
    }
  }
}
</style>